module.exports = __webpack_public_path__ + "static/img/kjdy15.d50fea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy15.png
// module id = 330
// module chunks = 0